export enum Promotion {
  PROMO_CTA_CLICK = 'PromotionCtaClickEvent',
  PROMO_CTA_CLICK_COMPLETED = 'PromotionCtaClickCompletedEvent',
  PROMO_CTA_CLICK_FAILURE = 'PromotionCtaClickFailureEvent',
  PROMO_CTA_MORE_INFO_CLICK = 'PromotionCtaMoreInfoClick',
  PROMO_CTA_DETERMINE_ACTION_CLICK = 'PromotionCtaDetermineActionClick',
}
